import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, message, Select,  Table } from 'antd';
import { Upload, Form, Input,DatePicker } from 'antd';

import { useNavigate } from "react-router-dom";

import moment from 'moment';
import {
    opt_product,
    opt_simu_vip,
    opt_pay_status,
    opt_high_domain,
    opt_demo_period,
    opt_yzg_environment,
    opt_fof_type,
    opt_roadshow,
    opt_design_template,
    opt_isdesgin,
    opt_need_ob,
    getOptionValue,
    getOptionLabel,
    getOptionValues,
    domain
  } from "../interface";
  
import "./index.css";
import { pad } from "lodash";

const { TextArea } = Input;
/**
 * 申请开通账户页
 */
const ApplyAccountPage = () => {
    const location = useLocation();
    const { selectedCustomer,customerName,selectUsers, selectedBussiness } = location.state || {};
    let navigate = useNavigate();
    // console.log("selectCustomer-2:",selectedCustomer)

    const [imageList, setImageList] = useState([]);
    const productLables= [];
    const productValues= [];
    // const [userId, setUserId] = useState("");
    // const [companyName, setCompanyName] = useState("");
    const getDefaultDate = () => {
        return moment().add(3, 'months');
    };

    const [trialDay, setTrialDay] = useState(getDefaultDate().format('YYYY-MM-DD'));
    const [simuVip, setSimuVip] = useState([]);   
    const [form] = Form.useForm();

    const handleSimuVipChange = (value) => {
        setSimuVip(value);
        // console.log(`selected ${simuVip}`);
        // console.log(`selected ${value}`);
      };
    // 遍历selectUsers数组，将每个对象的selectOpp属性的值添加到products数组中
    if (selectUsers) {
        selectUsers.map((user, index) => {
            console.log(`用户${index + 1}:`, user);
            user.selectOpp.map((item) => {
                // 判断products是否存在item.product_name,不存在，添加  
                if (!productLables.includes(item)) {
                    productLables.push(item);
                    productValues.push(getOptionValue(opt_product,item));
                }
            })
            
            
            // console.log("products",productValues.includes("option-1711969275366"),productLables,productValues)
            
            // 这里可以对每个用户对象进行操作
            return null; // map方法需要返回值
        });
    }
    
    useEffect(() => {
        const handlePaste = (e) => {
            const items = (e.clipboardData || window.clipboardData).items;
            for (const item of items) {
                if (item.type.indexOf('image') !== -1) {
                    const blob = item.getAsFile();
                    const file = new File([blob], 'pasted-image.png', { type: blob.type });
                    const formData = new FormData();
                    formData.append('file', file);
                    // 上传图片
                    fetch(`${domain}/upload`, { method: 'POST', body: formData })
                    .then(response => response.json())
                    .then(body => {
                        // console.log(body)                             
                        // 使用时间戳生成文件
                        const timestamp = Date.now();
                        const fileName = `pasted-image-${timestamp}.png`;                                                 
                        setImageList(prev => [...prev, {
                            uid: Date.now(),                            
                            name: fileName,
                            status: 'done',
                            imageId:body.imageId,
                            url: URL.createObjectURL(file)
                        }])
                    });
                }
            }
        };
    
        document.addEventListener('paste', handlePaste);
        return () => {
            document.removeEventListener('paste', handlePaste);
        };
    }, [])
    const contactColumns = [
        {
            title: '姓名',
            dataIndex: 'name',
            render: text => <a>{text}</a>,
        },
        {
            title: '开通产品',
            dataIndex: 'selectOpp',
            render: (value) => <div>{`${value.join('，')}`}</div>
        },
        {
            title: '手机',
            dataIndex: 'mobile1',
            render: (text) => <div>{getShowPhone(text + '')}</div>
        },
        {
            title: '邮箱',
            dataIndex: 'email',
        },
    ]

    const oppColumns = [
        {
            title: '商机名称',
            dataIndex: 'name',
            render: text => <a>{text}</a>,
        },
        {
            title: '产品',
            dataIndex: 'product_name',
        },
        {
            title: '盈率',
            dataIndex: 'probability',
            render: (value) => <div>{`${value}%`}</div>
        },

    ];

    const onDateChange = (date, dateString) => {
        console.log(date, dateString);
        setTrialDay(dateString)
      };

    /**
   * 电话号脱敏
   * @param {*} phone 
   * @returns 
   */
    const getShowPhone = (phone) => {
        const start = phone.substring(0, 3)
        const end = phone.substring(phone.length - 4)
        return `${start}****${end}`
    }

    const isShowSimVipField = () => {
        return productValues.includes("option-1711969275366") 
            && (simuVip.includes("option-1695636587761") || 
            simuVip.includes("option-1695636587762") ||
            simuVip.includes("option-1695636660429")
            )
    }
    /**
     * 调用接口
     */
    const applyAccount = (values) => {
        // console.log(values)
        if (productValues.includes("option-1711969275366") && simuVip.length === 0) {
            message.error("请选择易私慕平台服务")
            return
        }

        if (productValues.includes("option-1711969275367") && values.applyEmail === "") {
            message.error("请输入接收邮箱")
            return
        }
        

        let userId = localStorage.getItem("userId");
        let userName = localStorage.getItem("userName");
        if (userName == null || userName == "") {
          userName = "邢汝华";
        }
    
        if (userId == null || userId == "") {
          userId = "ruhua";
        }
        // console.log("values.trialDay",values.trialDay)
        let params = {
            "pcode":values.pcode,
            "userId":userId,
            "companyName":customerName,
            "product":productValues,
            "trialDay":trialDay,
            "isOB":values.isOB,
            "simuVip":simuVip,
            "isDesgin":values.isDesgin,
            "selectTemplate":values.selectTemplate,
            "isRoadShow":values.isRoadShow,
            "fofType":values.fofType,
            "applyEmail":values.applyEmail,
            "yzgEnvSelect":values.yzgEnvSelect,
            "productCount":values.productCount,
            "demoPriod":values.demoPriod,
            "payStatus":values.payStatus,
            "content":values.content,
            "workLoad":values.workLoad,
            "desginPrice":values.desginPrice,
            "highDomain":values.highDomain,
            "selectUsers":selectUsers,
            "businessData":selectedBussiness,
            "files": imageList.map(item => item.imageId),
        }
 
        console.log("params",params)
        // console.log("imageList",imageList)

        fetch(`${domain}/sale/applyform`, { method: 'POST', body: JSON.stringify(params) })
        .then(response => response.json())
        .then(body => {
            const data = body.data
            if (body.code !== "200") {
                message.error(`流程提交失败：${data.message} 文件上传失败`)
                return
            }
            navigate("/home");        
        })
        .finally(() => {
        });
    }

    return (
        <>
            <div className="container">
                <div className="apply_container">
                    <div className="user_name">{`客户名称：${customerName}`}</div>
                    <div className="main">
                    <div className="table_title">账号联系人</div>
                    <Table className="table_container" 
                        pagination={false} 
                        columns={contactColumns} 
                        dataSource={selectUsers} />
                    <div className="table_title">对应商机（25%以上）</div>
                    <Table className="table_container" 
                        columns={oppColumns} pagination={false}       
                        // scroll={{ x: 'calc(700px + 50%)', y: 47 * 5 }}
                        dataSource={selectedBussiness} />
					<Form
                        form={form}
                        labelCol={{span: 8,}}
                        wrapperCol={{span: 16,}}
                        layout="horizontal"
                        style={{width:'100%', maxWidth: 680,paddingTop: 24}} 
                        onFinish={applyAccount}     
                        initialValues={
                            {
                                isOB:opt_need_ob[0].value,
                                // simuVip:simuVip,
                                isDesgin:opt_isdesgin[0].value,
                                selectTemplate:opt_design_template[0].value,
                                isRoadShow:opt_roadshow[0].value,
                                fofType:opt_fof_type[0].value,
                                applyEmail:"空",
                                yzgEnvSelect:opt_yzg_environment[0].value,
                                productCount:0,
                                pcode:selectedCustomer.pcode,
                                payStatus:opt_pay_status[2].value,
                                demoPriod:opt_demo_period[0].value,
                                workLoad:0,
                                desginPrice:0,
                                highDomain:opt_high_domain[0].value,
                                content:"",
                                trialDay:getDefaultDate()
                            }
                        }    
                    >
                        <Form.Item
                            label="是否需要OB"
                            name="isOB"
                            // rules={[{ required: true,},]}
                        >
                            <Select 
                                // defaultValue={isOB} 
                                // key={opt_need_ob[0].value} 
                                // value={isOB} 
                                options={opt_need_ob} ></Select>  
                        </Form.Item>

                        <Form.Item
                            label="易私慕平台(V版）服务选择："
                            name="simuVip"
                            hidden={!productValues.includes("option-1711969275366")}
                        >
                            <Select
                                mode="multiple"
                                value={simuVip}
                                onChange={handleSimuVipChange}
                                options={opt_simu_vip}
                            ></Select>  
                        </Form.Item>                        

                        <Form.Item
                            label="易投研是否路演："
                            name="isRoadShow"
                            hidden={!productValues.includes("option-1711970763482")}
                        >
                            <Select   options={opt_roadshow} ></Select>  
                        </Form.Item>                        

                        <Form.Item
                            label="FOF账号类型："
                            name="fofType"
                            hidden={!productValues.includes("option-1711970816876")}
                        >
                            <Select   options={opt_fof_type} ></Select>  
                        </Form.Item>     
                                
                        <Form.Item
                            label="是否开通高域系统账号:"
                            name="highDomain"
                            hidden={!productValues.includes("option-1711970816876")}
                        >
                            <Select    options={opt_high_domain}></Select>  
                        </Form.Item>    

                        <Form.Item
                            label="易资管环境选择："
                            name="yzgEnvSelect"
                            hidden={!productValues.includes("option-1711969275367")}
                        >
                            <Select    options={opt_yzg_environment}></Select>  
                        </Form.Item>     
                        <Form.Item label="对接产品数" name="productCount" hidden={!productValues.includes("option-1711969275367")}>
                            <Input placeholder="对接产品数"  />
                        </Form.Item>    
                        <Form.Item label="账号接收邮箱：" name="applyEmail" hidden={!productValues.includes("option-1711969275367")}>
                            <Input placeholder="接收易资管/易估值安装包和账号" />
                        </Form.Item>                                        


                        <Form.Item
                            label="试用期时长:"
                            name="demoPriod"
                        >
                            <Select      options={opt_demo_period}></Select>  
                        </Form.Item>     
                                     

                        <Form.Item
                            label="付费情况确认:"
                            name="payStatus"
                        >
                            <Select     options={opt_pay_status}></Select>  
                        </Form.Item>     

                        <Form.Item
                            label="是否需要设计:"
                            name="isDesgin"
                            //是否包括 易直销 - 基础版 19800
                            hidden={!isShowSimVipField()}
                        >
                            <Select   options={opt_isdesgin}></Select>
                        </Form.Item>    

                        <Form.Item
                            label="选择设计模板:" name="selectTemplate" hidden={!isShowSimVipField()}>
                            <Select    options={opt_design_template}></Select> 
                        </Form.Item>    
                        <Form.Item label="给出设计报价"  name="desginPrice" hidden={!isShowSimVipField()}>
                            <Input placeholder=""   />
                        </Form.Item>          
                        <Form.Item label="设计工作量（人日）"  name="workLoad"  hidden={!isShowSimVipField()}>
                            <Input placeholder=""  />
                        </Form.Item>                                                                

                        <Form.Item label="账号到期时间" name="trialDay" >
                            <DatePicker 
                                 onChange={onDateChange}
                            />                        
                        </Form.Item>
                        <Form.Item label="协会备案号" name="pcode" >
                            <Input placeholder=""   disabled/>
                        </Form.Item>                                        

                        <Form.Item label="备注" name="content">
                            <TextArea rows={4}  placeholder="备注" />
                        </Form.Item>               


                        <Form.Item label="上传图片" name="imageUpload">
                            <Upload
                                fileList={imageList}
                                action= {`${domain}/upload`}
                                onChange={(info) => {
                                    // console.log("status",info.file.status);
                                    if (info.file.status === 'done') {
                                        message.success(`${info.file.name} 文件上传成功`);
                                        // console.log("info",info)
                                        
                                        info.fileList[info.fileList.length - 1].imageId=info.file.response.imageId
                                        // info.imageId=info.file.response.imageId

                                        setImageList(info.fileList)
                                        // console.log("imageList",info.fileList)
                                        return
                                    } else if (info.file.status === 'error') {
                                        message.error(`${info.file.name} 文件上传失败`);
                                    }

                                    
                                    setImageList(info.fileList)
                                }}
                                beforeUpload={(file) => {
                                    const isImage = file.type.startsWith('image/');
                                    if (!isImage) {
                                        message.error('只能上传图片文件！');
                                    }
                                    return isImage || Upload.LIST_IGNORE;
                                }}
                                listType="picture-card"
                                accept="image/*"
                            >
                                {imageList.length < 5 && '+ 上传'}
                            </Upload>
                        </Form.Item>


                        <Form.Item>
                            <Button type="primary" htmlType="submit">提交</Button>
                        </Form.Item>

                    </Form>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ApplyAccountPage